import { IaAnnotationsStore } from './IaAnnotationsStore';
import { IaDrawingStore } from './IaDrawingStore';
import { MarkupStore } from './MarkupStore';

export const stores = [
  IaAnnotationsStore,
  IaDrawingStore,
  MarkupStore
];



// WEBPACK FOOTER //
// ./src/shared/stores/image-analysis/annotations/index.js